import Fuse from 'fuse.js'

const FUSE_OPTIONS = {
  // Using as const is needed since the fuse typedef checks for
  // false value and not boolean.
  includeMatches: false as const,
  includeScore: false as const,
  ignoreDiacritics: true,
  shouldSort: true,
  threshold: 0.3,
  ignoreLocation: true,
}

export const createSearchIndex = <T extends Record<string, unknown>>(
  data: T[],
  keys: (keyof T)[]
): Fuse<T> => {
  return new Fuse(data, { ...FUSE_OPTIONS, keys: keys as string[] })
}
